// Constants
import { HEADERS_AND_PARAMS, SUBSCRIPTION_KEYS } from '../const/apis';

const getEnv = () => {
    const { host = '' } = window?.location ?? {};
    const [env = ''] = host.split('-ceridian');

    if (env.includes('localhost')) {
        return 'dev';
    }

    return env;
};

export const getApiUrlWithEnv = () =>
    `https://${getEnv()}-widget-apim.go2bankonline.com/pciwidget/v1`;

export const getSubscriptionKeyByEnv = () => {
    return SUBSCRIPTION_KEYS[getEnv().toUpperCase()];
};

export const getRequestParams = (searchParams, appConfig) => {
    if (!searchParams || !appConfig) {
        return {};
    }

    const code = searchParams.get('code');
    const accountIdentifier = searchParams.get('accountIdentifier');
    const requestId = searchParams.get('requestId');
    const sign = searchParams.get('sign');
    const programCode = searchParams.get('programCode');

    return { code, accountIdentifier, requestId, sign, programCode };
};

export const clearAccessToken = () => {
    if (sessionStorage.getItem(HEADERS_AND_PARAMS.ACCESS_TOKEN)) {
        sessionStorage.clear(HEADERS_AND_PARAMS.ACCESS_TOKEN);
    }
};

export const setAccessToken = (token) => {
    sessionStorage.setItem(HEADERS_AND_PARAMS.ACCESS_TOKEN, token);
};

export const getAccessToken = () => {
    return sessionStorage.getItem(HEADERS_AND_PARAMS.ACCESS_TOKEN);
};

const camelize = (str) => {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, idx) =>
            idx === 0 ? letter.toLowerCase() : letter.toUpperCase(),
        )
        .replace(/\s+/g, '');
};

export const camelizeObj = (obj) => {
    const keys = Object.keys(obj);
    const camelized = {};

    keys.forEach((key) => {
        const value = obj[key];
        const camelKey = camelize(key);

        if (typeof value === 'object' && !Array.isArray(value)) {
            camelized[camelKey] = camelizeObj(value);
        } else {
            camelized[camelKey] = value;
        }
    });

    return camelized;
};

export const normalizeResponse = (data) => {
    const resp = { ...data };

    return camelizeObj(resp);
};

export default {};
